







import { Component, Vue } from 'vue-property-decorator';

import { Player, Playlists } from '@/components';

@Component({
  components: {
    Player, Playlists,
  },
})
export default class Home extends Vue {
  private blockName: string = 'home-page';

  private ready: boolean = false;
}
